import React from 'react';

import { Tabs } from '@/components/ui/tabs';
import { TABS_CONFIG } from '../../constants';
import ConversationsPanel from './ConversationsPanel';
import Header from './Header';

const ConversationSelector = () => (
  <Tabs className="flex flex-col h-full" defaultValue={TABS_CONFIG[0].value}>
    <Header />
    <ConversationsPanel />
  </Tabs>
);

export default ConversationSelector;
